(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabCommand', TabCommand);

    TabCommand.$inject = ['$resource'];



    function TabCommand($resource) {
        var resourceUrl = 'api/tab-objects/action-by-id/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                cache: false
            },
            'get': {
                method: 'GET',
                cache: false
                // transformResponse: function (data) {
                //     data = angular.fromJson(data);
                //     return data;
                // }
            },
            'update': {method: 'PUT'}
        });
    }
})();
